interface ISettings {
  title: string // Overrides the default title
  showSettings: boolean // Controls settings panel display
  showTagsView: boolean // Controls tagsview display
  showSidebarLogo: boolean // Controls siderbar logo display
  fixedHeader: boolean // If true, will fix the header component
  errorLog: string[] // The env to enable the errorlog component, default 'production' only
  sidebarTextTheme: boolean // If true, will change active text color for sidebar based on theme
  showSidebarTheme: boolean  // 控制侧边栏的风格
}

// You can customize below settings :)
const settings: ISettings = {
  title: '电竞联盟-后台',
  showSettings: false,
  showTagsView: true,
  fixedHeader: true,
  showSidebarLogo: true,
  errorLog: ['production'],
  sidebarTextTheme: true,
  showSidebarTheme: false,
}

export default settings
